import { Theme } from "../../../components/constants"

export default {
    text: {
        fontSize: "14px",
        color: Theme.TEXT_PRIMARY_BLACK
    },
    mainContainer: {
        display: 'flex', 
        flexDirection: 'column', 
        gap: '50px'
    },
    checkboxDiv: {
        display: 'flex', 
        gap: '20px', 
        alignItems: 'center'
    },
    buttonPadding: {
        padding: '10px 20px'
    },
    rightsTable: {
        display: 'flex', 
        gap: '0px', 
        flexDirection: 'column'
    },
    rightsTableRow: {
        width: '60%', 
        display: 'flex', 
        borderBottom: '1px solid rgb(91, 98, 104)', 
        padding: '25px 0px'
    },
    flexOne: {
        flex: 1
    },
    buttonsRow: {
        display: 'flex', 
        gap: '20px'
    },
}